import 'bootstrap/dist/css/bootstrap.min.css';

export default function DeleteProjectModal({
setShowModal,
onDelete
})

{

    return (
         
        <div className="modal fade show d-block" id="DeleteProjectModal" tabindex="-1">
            <div className="modal-dialog">
                <div className="modal-content">

                    <div className="modal-header">
                        <h5 className="modal-title">Potwierdzenie</h5>
                        <button 
                        type="button"
                        className="btn-close"
                        onClick={() => setShowModal(false)}>
                        </button>
                    </div>

                    <div className="modal-body">
                        Czy na pewno chcesz usunąć projekt?
                    </div>

                    <div className="modal-footer">
                        <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
                        Anuluj
                        </button>
                        <button className="btn btn-danger"  onClick={onDelete}>
                        Usuń
                        </button>
                    </div>
                </div>
            </div>
        </div>
        

    )
}